import type { SeedDatabaseOptions } from "@/base/seed-test-database"

export const SEED_DATABASE_PHONE_NUMBER = {
  e164: "+15555555555",
  isVerified: true,
}

export const SEED_DATABASE_DEFAULTS: SeedDatabaseOptions = {
  activeFarmJoinCodeStatus: "ACTIVE",
  activeUserIsAdmin: false,
  activeUserPermissions: {
    canControlDevicesRemotely: true,
    canManageCustomTriggers: true,
    canManageDeviceConfiguration: true,
    canManageDeviceNotifications: true,
    canManageDevicePermissions: true,
    canManageFarmAccount: true,
    canManageFields: true,
    canManageJoinCodes: true,
    canManageSchedules: true,
    canManageUserPermission: true,
  },
  createVirtualDevice: null,
  markActiveFarmAsDemo: false,
  presetName: "demo",
  termsOfServiceAccepted: true,
  userPhoneNumbers: [
    {
      ...SEED_DATABASE_PHONE_NUMBER,
    },
  ],
  usesMetricSystem: false,
}
